<template>
    <svg viewBox="0 0 24 24" :width="size" :height="size">
        <circle cx="6" cy="12" r="3.5" fill="none" stroke="currentColor" stroke-width="1.4" />
        <circle cx="18" cy="12" r="3.5" fill="none" stroke="currentColor" stroke-width="1.4" />
        <line x1="10.3" y1="12" x2="13.7" y2="12" stroke="currentColor" stroke-width="1.4" />
        <circle cx="10.5" cy="12" r="0.5" fill="currentColor" />
        <circle cx="12" cy="12" r="0.5" fill="currentColor" />
        <circle cx="13.5" cy="12" r="0.5" fill="currentColor" />
    </svg>
</template>

<script setup lang="ts">
interface Props {
    size?: number | string
}

withDefaults( defineProps<Props>(), {
    size: 36
} )
</script>
